<template>
  <header>
    <p class="amount" v-if="step >= 2">
      <span>
        {{ donorInformation["donation-amount"] }}
      </span>
      {{
        this.donorInformation["allow-monthly-donation"]
          ? "monthly"
          : "once only donation"
      }}
    </p>
    <div class="donor" v-if="step >= 3">
      <div class="inner">
        <p>{{ displayName }}</p>
        <el-button
          v-if="step === 3 && donorInformation['donor-type'] === 'individual'"
          type="plain"
          @click="openEdit"
        >
          <img class="edit-ico" src="../../assets/icons/edit.svg" alt="" />
          Edit</el-button
        >
      </div>
      <p v-if="step >= 4 && showAddress">
        <i class="el-icon-location-outline"></i>
        {{ getAddress }}
      </p>
    </div>
    <el-form
      v-if="step === 3"
      class="edit-name"
      :class="{ isActive: editState }"
      @submit="save"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-input placeholder="First Name" v-model="firstName" />
        </el-col>
        <el-col :span="12">
          <el-input placeholder="Last Name" v-model="lastName" />
        </el-col>
      </el-row>
      <el-button type="primary" size="mini" @click="save">save</el-button>
    </el-form>
  </header>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      firstName: "",
      lastName: "",
    };
  },
  computed: {
    ...mapState({
      step: (state) => state.steps,
      donorInformation: (state) => state.donorInformation,
      donationConfig: (state) => state.donationConfig,
      editState: (state) => state.editState,
    }),
    getFullName() {
      return `${this.donorInformation["prefix"]} ${this.donorInformation["first_name"]} ${this.donorInformation["last_name"]}`;
    },
    corporateName() {
      return this.donorInformation["corporate-info"]["name"];
    },
    displayName() {
      if (this.donorInformation["donor-type"] === "individual") {
        return this.getFullName;
      } else {
        return this.corporateName;
      }
    },
    getAddress() {
      return `${this.donorInformation["address"].address_1}, ${this.donorInformation["address"].suburb} ${this.donorInformation["address"].state}, ${this.donorInformation["address"].post_code}`;
    },
    showAddress() {
      if (
        this.donorInformation.address.address_1.toLowerCase() === "address suppressed" ||
        this.donorInformation.address.suburb.toLowerCase() === "address suppressed"
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    ...mapMutations(["updateUserName", "toggleEdit"]),
    save() {
      if (this.firstName && this.lastName) {
        const name = {
          first_name: this.firstName,
          last_name: this.lastName,
        };
        this.updateUserName(name);
      }
      this.toggleEdit(false);
    },
    openEdit() {
      this.toggleEdit(true);
      (this.firstName = this.donorInformation.first_name),
        (this.lastName = this.donorInformation.last_name);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-icon-location-outline {
  color: #04adee;
  font-weight: bold;
}
.donor {
  background: #f5f5f5;
  padding: 16px 20px;
  border-radius: 2px;

  .inner {
    display: flex;
    align-items: center;
    justify-content: space-between;

    font-weight: bold;

    p {
      font-size: 16px;
      font-weight: bold;

      text-transform: capitalize;
    }

    .edit-ico {
      margin-right: 4px;
      transform: translateY(1px);
    }
  }
}

.amount {
  background: #f5f5f5;
  border-radius: 2px;
  font-size: 12px;

  height: 56px;
  display: flex;
  align-items: center;
  padding-left: 24px;

  span {
    position: relative;

    font-size: 24px;
    font-weight: bold;

    margin-right: 5px;

    &:before {
      content: "$";

      position: absolute;
      top: 3px;
      left: -7px;

      color: #04adee;
      font-weight: bold;
      font-size: 12px;
    }
  }
}
.edit-name {
  transition: all 0.3s ease;

  max-height: 0;
  overflow: hidden;

  margin-top: 10px;

  &.isActive {
    height: 100px;
    max-height: 100px;
  }

  .el-button {
    margin-top: 10px;
  }
}

// vue transition

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
